import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgIranzamin = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <g clipPath='url(#iranzamin_svg__a)'>
      <path
        fill='#5613A2'
        d='M7.047 1.616C8.363.707 9.917.122 11.52.02c1.255-.06 2.535-.016 3.743.361A11.7 11.7 0 0 1 21.56 4.62c-.524-.303-1.006-.678-1.553-.943-1.334-.665-2.79-1.11-4.28-1.21-.835-.137-1.675.015-2.505.108-1.133.218-2.248.597-3.233 1.202-1.144.74-2.16 1.697-2.864 2.874-1.277 2.091-1.606 4.693-1.039 7.06.152.66.389 1.295.622 1.928a12.2 12.2 0 0 1-2.04-3.319 10.74 10.74 0 0 1-.722-5.352c.19-1.376.703-2.718 1.55-3.826.468-.553.957-1.1 1.549-1.525zm-3.68 1.877c.342-.312.65-.673 1.054-.911-.193.341-.44.65-.622.997-.428.864-.845 1.743-1.056 2.688a10.3 10.3 0 0 0-.348 2.193c.006.741-.035 1.492.132 2.22.343 2.064 1.396 4.023 2.997 5.386 1.447 1.195 3.253 1.977 5.136 2.096.443.039.89.085 1.332.008.948-.06 1.883-.253 2.776-.574.321-.108.624-.264.952-.353-.828.814-1.851 1.399-2.883 1.917a10.34 10.34 0 0 1-5.513.973 7.8 7.8 0 0 1-3.102-.903c-.8-.477-1.577-1.024-2.183-1.735-.578-.74-1.124-1.526-1.43-2.421-.868-2.33-.77-4.95.055-7.28a11.7 11.7 0 0 1 2.702-4.3m8.006 1.238c2.055-.905 4.415-1.252 6.607-.66 1.377.392 2.708 1.07 3.682 2.133.98.97 1.626 2.233 2.006 3.547.966 3.676-.239 7.739-2.804 10.5-.428.428-.847.883-1.362 1.21 1.685-2.426 2.482-5.524 1.895-8.44-.387-1.975-1.422-3.828-2.967-5.132-1.627-1.445-3.824-2.11-5.973-2.138-1.18.085-2.364.27-3.473.696-.213.08-.423.17-.643.234a10 10 0 0 1 3.03-1.951zm5.871 3.546c.514.479.907 1.067 1.27 1.662.792 1.326 1.37 2.793 1.583 4.328.223 1.816.067 3.735-.77 5.39-.551 1.046-1.31 2.002-2.295 2.674-.942.739-2.075 1.182-3.23 1.458-1.093.16-2.21.306-3.311.126-1.954-.15-3.81-.944-5.43-2.02-.685-.434-1.271-1-1.837-1.577-.226-.244-.476-.473-.641-.768.817.469 1.626.964 2.523 1.28 1.514.61 3.15.86 4.78.73 1.698-.126 3.338-.757 4.727-1.732 1.12-.854 2.074-1.95 2.677-3.227.63-1.308.914-2.77.904-4.216a10.9 10.9 0 0 0-.665-3.342c-.085-.256-.205-.506-.286-.768'
      />
      <path
        fill='#FF0087'
        d='M11.295 7.561c2.038-.323 4.28.809 5.051 2.747a4.26 4.26 0 0 1-.085 3.48c-.243.618-.726 1.089-1.193 1.542-1.701 1.462-4.468 1.488-6.164.01-.441-.422-.881-.873-1.135-1.436-.568-1.137-.611-2.534-.063-3.686.625-1.428 2.066-2.412 3.588-2.657z'
      />
    </g>
    <defs>
      <clipPath id='iranzamin_svg__a'>
        <path fill='#fff' d='M0-.002h24v24H0z' />
      </clipPath>
    </defs>
  </svg>
)
const ForwardRef = forwardRef(SvgIranzamin)
export default ForwardRef
